import script from "./VatReturnsView.vue?vue&type=script&setup=true&lang=js"
export * from "./VatReturnsView.vue?vue&type=script&setup=true&lang=js"

import "./VatReturnsView.vue?vue&type=style&index=0&id=15fc7920&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15fc7920"]])

export default __exports__